import React from "react";
import SeLogoWhite from "../../../assets/icons/SeLogoWhite";
import classes from "./Footer.module.scss";
import ArrowWithTail from "../../../assets/icons/ArrowWithTail";
import { ReactComponent as X } from "../../../assets/icons/xTwitter.svg";
import { ReactComponent as LinkedIn } from "../../../assets/icons/linkedin.svg";
import { Link } from "react-router-dom";

const addresses = [
  {
    country: "SINGAPORE",
    address: "328 North Bridge Road, Raffles Hotel Arcade, Level 02-20 188719",
  },
  {
    country: "UNITED STATES",
    address: "One World Trade Center, Suite 8500, NY 10048",
  },
  {
    country: "INDIA",
    address:
      "Survey No. 133, Qube Software Park, 2, Bhoganahalli Rd, Hobli, East, Varthur, Bengaluru, Karnataka 560103",
  },
];

const linkSections: {
  sectionTitle: string;
  items: {
    title: string;
    link: string;
    isExternalLink?: boolean;
  }[];
}[] = [
  {
    sectionTitle: "Solutions",
    items: [
      {
        title: "CLEM",
        link: "CLEM",
        isExternalLink: true,
      },
      {
        title: "CLEM.ai",
        link: "CLEM.ai",
        isExternalLink: true,
      },
    ],
  },
  {
    sectionTitle: "Company",
    items: [
      {
        title: "About Us",
        link: "/about-us",
      },
      {
        title: "CEO’s Column",
        link: "/ceo-column",
      },
      {
        title: "Contact Us",
        link: "/contact-us",
      },
    ],
  },
  {
    sectionTitle: "Resources",
    items: [
      {
        title: "Press Release",
        link: "/resources/press-release",
      },
      {
        title: "Sustainability Economics News",
        link: "https://sustainabilityeconomicsnews.com/",
        isExternalLink: true,
      },
      {
        title: "Next Gen.ai News",
        link: "https://ngainews.com/",
        isExternalLink: true,
      },
    ],
  },
];

function Footer() {
  // const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  // };

  return (
    <div className={classes.container}>
      <div className={classes["logo-backtotop"]}>
        <SeLogoWhite />

        <div className={classes["backtotop"]}>
          <button
            aria-label="Back to top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Back to Top{" "}
            <ArrowWithTail color="#fff" width={13} height={10} rotation={-90} />
          </button>

          <p>Owned by Sustainability Economics</p>
        </div>
      </div>

      <div
        className={`${classes["horizontal-divider"]} ${classes["top-divider"]}`}
      ></div>

      <div className={classes["links-container"]}>
        {linkSections.map((section, index) => (
          <div key={index} className={classes["section"]}>
            <div className={classes["section-title"]}>
              {section.sectionTitle}
            </div>

            <div className={classes["horizontal-divider"]}></div>

            <div className={classes["items"]}>
              {section.items.map((item, index) => (
                <React.Fragment key={index}>
                  {item.isExternalLink ? (
                    <Link
                      to={item.link}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <Link to={item.link}>{item.title}</Link>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Connect with us !</label>
          <input name="email" id="email" placeholder="Your email"></input>
        </div>

        <button>Subscribe</button>
      </form> */}

      <div className={classes["addresses"]}>
        {addresses.map((address, index) => (
          <React.Fragment key={index}>
            <div className={classes["address"]}>
              <div className={classes["country"]}>{address.country}</div>
              <div className={classes["address-text"]}>{address.address}</div>
            </div>

            {index !== addresses.length - 1 && (
              <div className={classes["vertical-divider"]}></div>
            )}
          </React.Fragment>
        ))}
      </div>

      <div
        className={`${classes["horizontal-divider"]} ${classes["bottom-divider"]}`}
      ></div>

      <div className={classes["bottom-section"]}>
        <div className={classes["wrapper"]}>
          <div className={classes["social-media-links"]}>
            <Link
              to="https://www.linkedin.com/company/sustainabilityeconomics/mycompany/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <LinkedIn />
            </Link>

            <Link
              to="https://x.com/SE_NetZero"
              target="_blank"
              rel="noreferrer noopener"
            >
              <X />
            </Link>
          </div>
        </div>

        <div className={classes["terms-privacy"]}>
          <Link to="/terms">Terms & Conditions</Link>

          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>

        <p>
          © {new Date().getFullYear()} Sustainability Economics Pte Ltd. All
          Rights Reserved
        </p>
      </div>
    </div>
  );
}

export default Footer;
